// ----------------------------------------------------------------------------
// Snippet: Tooltip
// ----------------------------------------------------------------------------
//
// Some JS to handle touch devices
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_tooltip.scss';


// -------------------------------------
// Hooks
// -------------------------------------
$(document).ready(function(){
    
    // If you click anywhere outside the tooltip, close the tooltip
    $('body').on('click', function(event) {
        if (!$(event.target).closest('.tooltip').length) {
            $('.tooltip__content').removeClass('tooltip__content--visible tooltip__content--visible-locked');
        }
    });

    // When you hover the tooltip, add open state; if you hover or click, ensure it stays on screen
    $('body').on('click mouseenter focusin', '.tooltip', function(event) {
        $(this).children('.tooltip__content').addClass('tooltip__content--visible');

        // Ensure the tooltip stays on the screen
        if ($(this).children('.tooltip__content').offset().left < 0) {
            $(this).children('.tooltip__content').offset({left: 15});
        }
    });

    // Once your mouse leaves, remove open for hover
    $('body').on('mouseleave focusin', '.tooltip', function(event) {
        $(this).children('.tooltip__content').removeClass('tooltip__content--visible');
    });

    // When you click the tooltip, toggle the open state
    $('body').on('click', '.tooltip',function(event) {
        $(this).children('.tooltip__content').toggleClass('tooltip__content--visible-locked');
    });
});
